import styled from 'styled-components';
import { FastCss, FastCssProps } from '../Common/FastCss';

export type FlexDirection = 'row' | 'row-reverse' | 'column' | 'column-reverse';

type FlexBoxProps = Omit<FastCssProps, 'display'> & {
    direction?: FlexDirection;
    inline?: boolean;
    flex?: boolean | string;
    gap?: number;
    x?: 'flex-start' | 'center' | 'flex-end' | 'space-around' | 'space-between' | 'space-evenly';
    y?: 'flex-start' | 'center' | 'flex-end' | 'space-around' | 'space-between' | 'space-evenly';
    childFull?: boolean;
};

export const JRCFlexBox = styled.div<FlexBoxProps>`
    ${FastCss};
    display: ${({ inline }) => (inline ? 'inline-flex' : 'flex')};
    gap: ${({ gap }) => gap ?? 8}px;
    ${({ flex }) => flex && `flex: ${flex}`};

    ${({ direction }) => direction && `flex-direction: ${direction}`};
    ${({ direction, x, y }) =>
        !direction || direction === 'row' ? x && `justify-content: ${x}` : y && `justify-content: ${y}`};
    ${({ direction, x, y }) =>
        !direction || direction === 'row' ? y && `align-items: ${y}` : x && `align-items: ${x}`};
    ${({ childFull }) => childFull && '& > * { width: 100% }'};
`;

export type JRCFlexBoxProps = FlexBoxProps & {
    as?: string;
};
